import React from 'react'
import './index.scss'

import img from '../../assets/individual.eglo-b2b.webp'
import HoverButton from '../HoverButton'
import fullservice from '../../assets/projekte/alupress/fullservice.webp'

const ImageList = ({
  title,
  subTitle,
  hasButton = false,
  buttonText = 'zum Kontakt',
  buttonLink = '/kontakt',
  img = fullservice,
  item1,
  item2,
  item3,
  item4,
  item5,
  item6,
}) => {
  const gaEvent = () => {
    if (typeof gtag === 'function') {
      let date = Date.now()
      gtag('event', 'technologie_imglist-kontakt', {
        time: date,
      })
    }
  }

  return (
    <div className="imagelist" id="start">
      <div className="container">
        <div className="imagelist__col__heading">
          <h2>{title}</h2>
          <p className="imagelist__subheading">{subTitle}</p>
        </div>
        <div className="imagelist__container">
          <div className="imagelist__col">
            <div className="imagelist__col__item">
              <div className="imagelist__col__item-heading">
                <h4>{item1.heading}</h4>
              </div>
              <div className="imagelist__col__item-text">
                <p>{item1.text}</p>
              </div>
            </div>
            <div className="imagelist__col__item">
              <div className="imagelist__col__item-heading">
                <h4>{item2.heading} </h4>
              </div>
              <div className="imagelist__col__item-text">
                <p>{item2.text}</p>
              </div>
            </div>
          </div>

          <div className="imagelist__col">
            {/* mid */}
            <div className="imagelist__col__image">
              <img src={img} alt="" loading="lazy" />
            </div>
            {hasButton && (
              <HoverButton
                dataTitle="Wieso warten?"
                dataText={buttonText}
                link={buttonLink}
                onClick={gaEvent()}
              />
            )}
          </div>

          <div className="imagelist__col">
            <div className="imagelist__col__item">
              <div className="imagelist__col__item-heading">
                <h4>{item3.heading}</h4>
              </div>
              <div className="imagelist__col__item-text">
                <p>{item3.text}</p>
              </div>
            </div>
            <div className="imagelist__col__item">
              <div className="imagelist__col__item-heading">
                <h4>{item4.heading}</h4>
              </div>
              <div className="imagelist__col__item-text">
                <p>{item4.text}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="imagelist__bottom">
          <div className="imagelist__col__item">
            <div className="imagelist__col__item-heading">
              <h4>{item5.heading}</h4>
            </div>
            <div className="imagelist__col__item-text">
              <p>{item5.text}</p>
            </div>
          </div>
          <div className="imagelist__col__item">
            <div className="imagelist__col__item-heading">
              <h4>{item6.heading}</h4>
            </div>
            <div className="imagelist__col__item-text">
              <p>{item6.text}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ImageList
